import React from 'react'
import Select, { components } from "react-select";

import './Select.css'

export function CustomSelect(props) {

	const { Option } = components;

	const IconOption = props => {
		 
		return (
			<Option {...props} className={'custom-select__option-has_icon'}>
				<span className="custom-select__option-icon" >{props?.data?.icon}</span>
				<span className="custom-select__option-text" >{props?.data?.label}</span>
			</Option>
		)
	} ;


	const Control = ({ children, ...props }) => {
		
		const { value  } = props.selectProps;
		const { icon } = value ?? {};
		
		return (
			<components.Control {...props}>
			  <span className="icon">{icon}</span>
			  {children}
			</components.Control>
		  )
	};

	return (
		<div className={`field-group`}>
			{props.label && <label>{props.label} {props.required ? '*' : ''}</label>}
			<div className={`input-wrapper select-wrapper ${props.error ? 'error' : ''}`}>
			{/* <select 
					className={`${props.className ?? ''} ${props.error ? 'error' : ''}`} {...props}>
					{
						props?.data.map( (item , index) => {
							return (
								<option key={index} value={item?.value} selected={props.value === item?.value ? true : false }>{item?.label}</option>
							)
						})
					}
				</select> */}
				<Select
					 
					options={props.data}
					// width={props.width ?? '100%'}
					classNamePrefix="custom-select"
					// { withIcons && components={{ Option: IconOption }}}
					{...props}
					// menuIsOpen={true}
					components={ 
							props.showIcons === true 
							? { Option: IconOption , Control }
							: {}
						}
					 
				/>
			</div>
			{ props.error && <div className='field--error'>{props.error}</div>}
			{ props.note && <div className='field--note'>{props.note}</div>}
		</div>
	)
}
